import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { FocusShell, FocusShellFailure } from '../components/FocusShell';
import { Spinner } from '../components/Spinner';
import { describeError } from '../lib/errors';

const Callback: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Only auto-redirect on success; an error stays on this page so the
    // user can read what happened and go back to sign in deliberately.
    if (auth.isAuthenticated) {
      const returnTo = (auth.user?.state as { returnTo?: string })?.returnTo;
      navigate(returnTo || '/my-apps');
    }
  }, [auth.isAuthenticated, auth.user, navigate]);

  useEffect(() => {
    if (auth.error) {
      console.error('Authentication callback error:', auth.error);
    }
  }, [auth.error]);

  if (auth.error) {
    // The same failure ProtectedRoute renders: the h1 and the alert title say
    // what failed, so the body is only the cause (no context prefix).
    return (
      <FocusShell title="Couldn't sign you in">
        <FocusShellFailure
          alertTitle="Sign-in failed"
          message={describeError(auth.error).message}
          action={
            <Button asChild className="w-full">
              <Link to="/login">Back to sign in</Link>
            </Button>
          }
        />
      </FocusShell>
    );
  }

  return (
    // Branding stays visible through the auth handoff.
    <FocusShell title="Welcome to Dory" description="Sees everything on the street. Remembers nothing.">
      <Card>
        <CardContent className="flex flex-col items-center py-10">
          <Spinner size="lg" label="Completing authentication…" />
        </CardContent>
      </Card>
    </FocusShell>
  );
};

export default Callback;
